import React from 'react'
import MenuIcon from './MenuIcon'
import '../styles/navbar.css'

const Navbar = (props) => {
    return (
        <header className={props.scroll ? 'navbar' : 'black__navbar'}>
            <nav className="navbar__navigation">
                <div>
                </div>
                <div className="navbar__logo">
                    <img src={require('../../static/img/logo.png')} />
                </div>
                <div className="spacer" />
                <div className={props.scroll ? 'navbar__items' : 'navbar__black__items'}>
                    <ul>
                        <li><a href='https://activebuildings.in' > HOME </a></li>
                        <li><a href='https://activebuildings.in/solutions'> SOLUTIONS </a></li>
                        <li><a href='https://activebuildings.in/case' > CASE STUDIES </a></li>
                        <li><a href='https://activebuildings.in/about'> ABOUT US </a></li>
                        <li><a href='https://activebuildings.in/contact'> CONTACT US </a></li>
                        <li><a href='/'> BLOG </a></li>
                        <li><a href='https://dashboard.activebuildings.in/login'> LOGIN </a></li>
                    </ul>
                </div>
                <div className='menu__button'>
                    <MenuIcon toggleDrawer={props.toggleDrawer} />
                </div>
            </nav>
        </header>

    )
}


export default Navbar